import { decompress } from './lzmaRuntime.js'

import { MAX_COMPRESSED_HEADER, MAX_UNPACKED_HEADER } from './constants'
import { ArchiveError } from './errors'

const MIN_DICTIONARY = 4096

export const decodeLzmaHeader = (props: Uint8Array, packed: Uint8Array, unpackedSize: number): Uint8Array => {
  if (packed.byteLength > MAX_COMPRESSED_HEADER || unpackedSize < 0 || unpackedSize > MAX_UNPACKED_HEADER) {
    throw new ArchiveError('header-too-large')
  }
  if (props.byteLength < 5) throw new ArchiveError('unsupported')
  const stream = new Uint8Array(13 + packed.byteLength)
  stream.set(props.subarray(0, 5), 0)
  const view = new DataView(stream.buffer)
  const dictionary = view.getUint32(1, true)
  view.setUint32(1, Math.min(dictionary, Math.max(unpackedSize, MIN_DICTIONARY)), true)
  view.setBigUint64(5, BigInt(unpackedSize), true)
  stream.set(packed, 13)
  const out = decompress(stream)
  if (out.byteLength !== unpackedSize) throw new ArchiveError('unsupported')
  return out
}
